import { useEffect, useState } from "react";
import Confetti from "react-confetti-boom";

export default function ConfettiComponent() {
  const [confettiProps, setConfettiProps] = useState({ x: 0.5, y: 0.5 });
  const delay = 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      setConfettiProps({
        x: Math.random() * (0.7 - 0.3) + 0.3,
        y: Math.random() * (0.5 - 0.2) + 0.2,
      });
    }, delay);

    return () => clearInterval(interval);
  }, []);

  return (
    <Confetti
      effectCount={Infinity}
      effectInterval={delay}
      particleCount={60}
      spreadDeg={45}
      x={confettiProps.x}
      y={confettiProps.y}
    />
  );
}
